const useValidate = (refs) => {
    let bools = [];
    const refKeys = Object.keys(refs);
    if (refKeys.length > 0) {
        refKeys.forEach(key => {
            const ref = refs[key];
            if (ref && ref.validateForm) {
                const error = ref.validateForm();
                if (error) {
                    bools.push(error);
                }
            }
            // if (refs[key] !== undefined && refs[key].v$ !== undefined) {
            //     refs[key].v$.$touch()
            //     bools.push(refs[key].v$.$error)
            // }
        });
    }
    const hasError = bools.includes(true);
    // If error, scroll to first error ref
    if (hasError) {
        // refs[refKeys[0]].$el.scrollIntoView()
    }
    return hasError;
};
export default useValidate;
